import { IBaseModel, BaseModel } from "../base.model";

export interface IReceptionDetailViewModel extends IBaseModel {
  apartment?: { apartment_number: string, location_number: string, id: number }
  pdf_report?: string;
  name?: string
  block?: {
    address: {
      city: string;
      country: string;
      line1: string
      zip_code: string
    }
    name: string

  }
  nb_ko_item?: string
  createdBy?: {
    firstname: string;
    lastname: string;
    id: number
  }
  participants?: { entity: { firstname: string, lastname: string } }[]
  vehicle?:{brand?:string, id?:number, name?:string, reference?:string}
}
export class ReceptionDetailViewModel extends BaseModel implements IReceptionDetailViewModel {
  apartment?: { apartment_number: string, location_number: string, id: number }
  pdf_report?: string;
  name?: string
  participants?: { entity: { firstname: string, lastname: string } }[]
  block?: {
    address: {
      city: string;
      country: string;
      line1: string
      zip_code: string
    }
    name: string
    line1: string
    zip_code: string
  }
  nb_ko_item?: string
  createdBy?: {
    firstname: string;
    lastname: string;
    id: number
  }
  vehicle?:{brand?:string, id?:number, name?:string, reference?:string}
}



// WEBPACK FOOTER //
// ./src/models/reception/reception-detail.viewmodel.ts